export const BUTTON_PRIMARY_ICON_FONT_SIZE = "2.5rem";
export const BUTTON_SECONDARY_ICON_FONT_SIZE = "1.5rem";
